import React from "react";
import partnerMerchant from "../assets/partners-icon/partnert-merchant.svg";

const Partners = () => {
  return (
    <div className="partners">
      <div className="partners-wrapper container">
        <div className="partners-left">
          <img className="partners-icon" src={partnerMerchant} alt="partner merchant" />
          <div className="partners-content">
            <p className="partners-content-title">Ingin Bergabung Menjadi Mitra MoshiMoshiMall?</p>
            <p className="partners-content-desc">Mudah, nyaman dan bebas komisi transaksi. <span>GRATIS!</span></p>
          </div>
          <button className="partners-button">Gabung Mitra Sekarang</button>
        </div>
        <p className="partners-link">Pelajari Lebih Lanjut</p>
      </div>
    </div>
  );
};

export default Partners;
